module.exports = __webpack_public_path__ + "static/media/pitch_system.33b6d3a3.png";